module.exports = __webpack_public_path__ + "static/media/westpac_logo.675082d5.png";